import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900">
            {t('testimonials.heading')}
          </h2>
        </div>

        <div className="relative bg-foreground-900 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-[45%] relative -ml-0 lg:-ml-12 mt-0 lg:-mt-8 mb-0 lg:-mb-8">
              <div className="rounded-2xl overflow-hidden h-full min-h-[350px] lg:min-h-[500px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20man%20in%20casual%20modern%20streetwear%20standing%20confidently%20against%20a%20warm%20terracotta%20studio%20wall%2C%20genuine%20smile%2C%20soft%20diffused%20natural%20light%2C%20relaxed%20portrait%20photography%2C%20warm%20earthy%20color%20palette%2C%20lifestyle%20fashion%20editorial%20style%2C%20clean%20minimal%20composition&width=800&height=1000&seq=testimonial-v2-a0b1&orientation=portrait"
                  alt="Cliente satisfeito CSSBuy"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="lg:w-[55%] flex flex-col justify-center px-8 md:px-12 py-10 lg:py-16">
              <span className="font-heading text-7xl md:text-8xl text-primary-300/40 leading-none mb-4 select-none">
                &ldquo;
              </span>
              <p className="text-white/90 text-base md:text-lg leading-relaxed mb-8">
                {t('testimonial.quote')}
              </p>
              <div className="mb-8">
                <p className="text-white font-semibold text-sm">
                  {t('testimonial.name')}
                </p>
                <p className="text-white/50 text-xs mt-1">
                  {t('testimonial.role')}
                </p>
              </div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-secondary-400 text-foreground-900 font-semibold text-sm hover:bg-secondary-300 transition-all duration-200 whitespace-nowrap w-fit"
              >
                {t('testimonial.cta')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}